import React, { createContext, useEffect, useState } from "react";
import { PropsType } from "../../interfaces/ChildrenType";
import { CardsResultContextType } from "./cards-types";
import { PaymentMethods } from "../../interfaces/Loan";

const CardsData = sessionStorage.getItem("pepper-user-cards-data");
const initialState: CardsResultContextType = {
  cardsResult: JSON.parse(CardsData as string) || undefined,

  setCardsResult: () => { },
};

export const CardsResultContext = createContext(initialState);

export const CardsResultContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [cardsResult, setCardsResult] = useState<
  PaymentMethods | undefined
  >(initialState.cardsResult);

  useEffect(() => {
    if (cardsResult) {
      sessionStorage.setItem('pepper-user-cards-data', JSON.stringify(cardsResult))
    } else {
      sessionStorage.removeItem("pepper-user-cards-data");
    }
  }, [cardsResult])

  return (
    <CardsResultContext.Provider
      value={{ cardsResult, setCardsResult }}
    >
      {children}
    </CardsResultContext.Provider>
  );
};
